"use strict";

var _regeneratorRuntime = require("/Users/winza/workspace/storeman-webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var dynamoServices = _interopRequireWildcard(require("../../services/dynamodb"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useFormInput(initValue, uid, name) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _useState = (0, _react.useState)(initValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1]; //text input


  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEdit = _useState4[0],
      setIsEdit = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      oldState = _useState6[0],
      setOldState = _useState6[1];

  var openEditMode = function openEditMode() {
    setIsEdit(true);
    setOldState(value);
  };

  var cancelEdit = function cancelEdit() {
    setValue(oldState);
    setIsEdit(false);
  };

  function handleChange(evt) {
    setValue(evt.target.value);
  }

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return dynamoServices.get(uid, name, options || {});

            case 3:
              data = _context.sent;
              setValue(data.Item.value);
              setOldState(data.Item.value);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));
    return _fetch.apply(this, arguments);
  }

  (0, _react.useEffect)(function () {
    fetch();
  }, []);

  function save(_x) {
    return _save.apply(this, arguments);
  }

  function _save() {
    _save = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(cbSuccess) {
      var data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return dynamoServices.update({
                table: options.table,
                uid: uid,
                name: name,
                value: options.isInteger ? parseInt(value) : value
              });

            case 3:
              data = _context2.sent;

              if (cbSuccess) {
                cbSuccess instanceof Function && cbSuccess(value);
              } else {
                alert("Data has been saved");
              }

              setIsEdit(false);
              setOldState(value);
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              alert(_context2.t0.message);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return _save.apply(this, arguments);
  }

  return {
    setIsEdit: setIsEdit,
    value: value,
    onChange: handleChange,
    getInt: function getInt() {
      return parseInt(value);
    },
    setValue: setValue,
    getValue: function getValue() {
      return value || null;
    },
    isEdit: isEdit,
    cancelEdit: cancelEdit,
    openEditMode: openEditMode,
    save: save,
    setOldState: setOldState
  };
}

var _default = useFormInput;
exports.default = _default;